import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { SPARTAN_PRODUCT_BUTTON_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import type { SpartanLineupModelCardActionsProps } from '@/app/lcv/components/sections/spartan/shared/lineup/carousel/model-card/actions/types';
import { SPARTAN_LINEUP_LABELS } from '@/app/lcv/components/sections/spartan/shared/lineup/constants';
import { SPARTAN_LINEUP_DATA_GA, SPARTAN_LINEUP_TRACKING } from '@/app/lcv/components/sections/spartan/shared/lineup/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const SpartanLineupModelCardActions = t0 => {
  const $ = _c(26);
  const {
    modelHref,
    compareHref,
    modelIndex,
    eventName,
    isDark,
    onPrefetchDetail
  } = t0;
  let t1;
  if ($[0] !== modelIndex) {
    t1 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelCta(modelIndex)
    });
    $[0] = modelIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== modelIndex) {
    t2 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.detailButton(modelIndex)
    });
    $[2] = modelIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== eventName || $[5] !== modelHref) {
    t3 = createDataGA({
      eventName,
      group: SPARTAN_LINEUP_DATA_GA.section,
      click: true,
      text: SPARTAN_LINEUP_LABELS.detail,
      url: modelHref
    });
    $[4] = eventName;
    $[5] = modelHref;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== modelHref || $[8] !== onPrefetchDetail || $[9] !== t2 || $[10] !== t3) {
    t4 = <Button href={modelHref} prefetch={false} onMouseEnter={onPrefetchDetail} onFocus={onPrefetchDetail} onTouchStart={onPrefetchDetail} color="black" size="md" width="min" className={SPARTAN_PRODUCT_BUTTON_CLASS_NAME} {...t2} {...t3}>{SPARTAN_LINEUP_LABELS.detail}</Button>;
    $[7] = modelHref;
    $[8] = onPrefetchDetail;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = isDark ? "white" : "black";
  let t6;
  if ($[12] !== modelIndex) {
    t6 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.compareButton(modelIndex)
    });
    $[12] = modelIndex;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== compareHref || $[15] !== eventName) {
    t7 = createDataGA({
      eventName,
      group: SPARTAN_LINEUP_DATA_GA.section,
      click: true,
      text: SPARTAN_LINEUP_LABELS.compare,
      url: compareHref
    });
    $[14] = compareHref;
    $[15] = eventName;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== compareHref || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <Button href={compareHref} color={t5} variant="tertiary" size="md" width="min" className={SPARTAN_PRODUCT_BUTTON_CLASS_NAME} {...t6} {...t7}>{SPARTAN_LINEUP_LABELS.compare}</Button>;
    $[17] = compareHref;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t1 || $[23] !== t4 || $[24] !== t8) {
    t9 = <div className="mt-auto flex flex-col gap-2 pt-2" {...t1}>{t4}{t8}</div>;
    $[22] = t1;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};